import { getHelpCenterAri } from '@helpcenter/meta';
import { RequestList } from 'view/request-list';
import { UserProfile } from 'view/user-profile';
import { HelpHelpCenterAri } from '@atlassian/ari';
import { CsmContactUs } from '@atlassian/csm-contact-us';
import { CsmRequestsList } from '@atlassian/csm-requests-list';
import { csmRequestsListQueryResource } from '@atlassian/csm-requests-list/src/services/csm-requests-list-resource';
import { getHoistedProjectKey, getJiraDisplayUrl } from '@atlassian/help-center-common-util/env';
import { getRelativeBasePath } from '@atlassian/help-center-common-util/history';
import { initialModel } from '@atlassian/help-center-common-util/model';
import { createHubHomepageRoute, createRouteWithHubShell } from '@atlassian/hub';
import { logOutAction } from '../../epics/logout';
import { store } from '../../providers';
import { HUB_ROUTES } from './constants';

const initialModelState = initialModel();

const hubRouteProps = {
    user: {
        email: initialModelState.user?.email || '',
        displayName: initialModelState.user?.displayName || '',
        avatarSrc: initialModelState.user?.avatars?.xlarge || '',
        isJiraAdmin: initialModelState.user?.canAdministerJIRA || false,
    },
    env: {
        helpCenterId: HelpHelpCenterAri.parse(getHelpCenterAri()).helpCenterId,
        jiraDisplayUrl: getJiraDisplayUrl(),
        hoistedProjectKey: getHoistedProjectKey() || '',
        relativeBaseUrl: getRelativeBasePath(),
    },
    layout: {
        showSearch: false,
    },
    actions: {
        onLogoutClick: () => {
            const action = logOutAction();
            store.dispatch(action);
            return action;
        },
    },
};
export const hubHomepageRoute = createHubHomepageRoute(hubRouteProps);

export const userProfileRouteWithHubShell = createRouteWithHubShell(
    hubRouteProps,
    UserProfile,
    HUB_ROUTES.USER_PROFILE.path,
    HUB_ROUTES.USER_PROFILE.name,
    [],
    'normal'
);

export const csmRequestsListRouteWithHubShell = createRouteWithHubShell(
    hubRouteProps,
    CsmRequestsList,
    HUB_ROUTES.CSM_REQUESTS_LIST.path,
    HUB_ROUTES.CSM_REQUESTS_LIST.name,
    [csmRequestsListQueryResource],
    'xxwide'
);

export const requestsListRouteWithHubShell = createRouteWithHubShell(
    hubRouteProps,
    RequestList,
    HUB_ROUTES.REQUESTS_LIST.path,
    HUB_ROUTES.REQUESTS_LIST.name,
    [],
    'xxwide'
);

export const csmContactUsRouteWithHubShell = createRouteWithHubShell(
    hubRouteProps,
    CsmContactUs,
    HUB_ROUTES.CSM_CONTACT_US.path,
    HUB_ROUTES.CSM_CONTACT_US.name,
    [],
    'wide'
);
